import React from "react";
import UserLoginForm from "../../../components/User/UserLogin/UserLogin";

export default function UserLogin (){
    return(
        <div>
            <main className="main-content  mt-0">
                {/*<Login/>*/}
                {/*<LoginForm/>*/}
                <UserLoginForm/>
            </main>
        </div>
    )
}